<template>
  <div class="footer">
     <div class="footer_container">
        <div class="footer_top">
            <div class="footer_logo">
                <img src="../../assets/footer/资源 57.png">
            </div>
        </div>
        <div class="footer_middle">
            <div class="middle_left">
                <div class="left_link">
                    <div v-for="(item, index) in bottomLink" :key="index" class="link_item">
                        <p class="title" style="color: #dadada; font-family: AliMedium;" ><span @click="goPage(item.url)">{{ item.title }}</span></p>
                        <p class="title_child" v-for="(link, i) in item.content" :key="i" @click="goPage(link.url)">
                            <span  @click="goPage(link.url)">{{ link.title }}</span>
                        </p>
                    </div>
                </div>
                <div class="right_link">
                    <p ><span @click="goPage('/models')">模型库</span></p>
                    <p><span>帮助中心</span></p>
                    <p ><span @click="goPage('/about')">关于矢量</span></p>
                    <p ><span @click="goPage('/advice')">意见反馈</span></p>
                </div>
            </div>
            <div class="middle_right">
                <div class="right_number">
                    <p style="color: #ffffff; font-size: 1rem;">400-8766-576</p>
                </div>
                <div class="right_code">
                    <img src="../../assets/footer/资源 59.png">
                    <p style="color: #ffffff; font-size: 0.75rem;">扫一扫关注公众号</p>
                </div>
            </div>
        </div>
        <div class="footer_middle_bottom">
            <div v-for="(item, index) in bottomContact" :key="index" :class="index!==3 ? 'bottom_contact contact_border' : 'bottom_contact'">
                <div class="contact_border_inner">
                    <div style="margin-right: 1rem; display: flex; align-items: center;">
                        <img :src="item.imgUrl" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: center;">
                        <p style="font-size: 0.9rem; color: #969696; font-family: AliMedium;">{{ item.title }}</p>
                        <p style="font-size: 0.9rem; color: #dadada; font-family: AliMedium;">{{ item.content }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer_bottom">
            <div class="copyright">
                @2019-2025 青岛矢量数字科技有限公司 
                <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备19001481号-4</a>
            </div>
        </div>
     </div>
     <div class="dialog-container">
        <el-dialog title="留言及反馈" :visible.sync="showDialog" width="60%" @close="closeDialog" :close-on-click-modal="false">
            <div class="header">
                <div class="avatar">
                    <img :src="userInformation.avatar">
                </div>
            </div>
            <div class="container">
                <el-form class="form-container" :model="form" :rules="rules" ref="form" label-width="60px">
                    <div class="top">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="form.name" maxlength="15"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="phone">
                            <el-input v-model="form.phone" maxlength="16"></el-input>
                        </el-form-item>
                    </div>
                    <div class="bottom">
                        <el-form-item label="邮箱" prop="email">
                            <el-input v-model="form.email" maxlength="40"></el-input>
                        </el-form-item>
                        <el-form-item label="单位" prop="unit">
                            <el-input maxlength="20" v-model="form.unit"></el-input>
                        </el-form-item>
                    </div>
                    <el-form-item class="content" prop="content">
                        <el-input maxlength="400" type="textarea" v-model="form.content" :rows="5"></el-input>
                    </el-form-item>
                    <el-form-item class="btn">
                        <el-button  @click="submitForm('form')">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>

        </el-dialog>
     </div>
  </div>
</template>

<script>
import { getUserInfo, userMessage } from '../../util';
import { bottomLink, bottomContact } from '../../util/constant'
export default {
    name: 'Footer',
    data() {
        return {
            bottomLink,
            bottomContact,
            showDialog: false,
            userInformation: {
                avatar: require('../../assets/image/资源 38.png'),
                account: ''
            },
            form: {
                name: '',
                phone: '',
                email: '',
                unit: '',
                content: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                    { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' }
                ],
                phone: [
                { 
                        validator: async (rule, value, callback) => {
                            var myReg=/^[1][3,4,5,7,8][0-9]{9}$/;
                            if (value === '') {
                                callback(new Error('手机号不能为空'));
                            }else if (!myReg.test(value) ) {
                                callback(new Error('请输入正确的手机号码'));
                            } else {
                                callback();
                            }
                        }, 
                        required: true,
                        trigger: 'blur' 
                    }
                ],
                content: [
                    { required: true, message: '请输入反馈内容', trigger: 'blur' }
                ],
                email: [
                    {
                        validator: async (rule, value, callback) => {
                            var myReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
                            if( value === ''){
                                callback(new Error('请输入邮箱'))
                            }
                            else if (!myReg.test(value) ) {
                                callback(new Error('请输入正确的邮箱'));
                            } else {
                                callback();
                            }
                        },
                        required: true,
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    methods:{
        goPage(url){
            this.$router.push(url)
        },
        openAdvice(){
            this.showDialog = true
            let obj = {
                token: window.localStorage.getItem('userToken'),
            }
            getUserInfo(obj).then(res=>{
                if (res.code === 200){
                    this.userInformation.avatar = res.data.avatar
                    this.userInformation.account = res.data.username
                    this.state = true
                }
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        name: this.form.name,
                        phone: this.form.phone,
                        content: this.form.content,
                    }
                    if(this.form.email) obj.email = this.form.email
                    if(this.form.unit) obj.unit = this.form.unit
                    let token = window.localStorage.getItem('userToken')
                    userMessage(obj, token).then(res=>{
                        if (res.code === 200){
                            this.$message({
                                message: '已收到您的反馈，我们会尽快回复您',
                                type: 'success'
                            });
                            this.closeDialog()
                        }
                        }
                    )
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        closeDialog(){
            this.showDialog = false
            this.$refs['form'].resetFields();
            this.$refs['form'].clearValidate();
        }
    }
}
</script>

<style scoped lang="less">
*{
    margin: 0;
    padding: 0;
    list-style: none;
}
a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的文本颜色 */
}
.footer {
    width: 100%;
    height: 36.38rem;
    background-image: url("../../assets/footer/资源63.png");
    // background-image: url("../../assets/image/9.png");
    background-size: cover;
    min-width: 1800px;
    @media screen and (max-width: 1800px) {
        min-width: 1200px;
    }
    .footer_container{
        margin: 0 auto;
        height: 100%;
        max-width: 60rem;
        // background-image: url("../../assets/footer/资源63.png");
        // background-size: cover;
        .footer_top{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 3.75rem 0 2.56rem;
        }
        .footer_middle{
            display: flex;
            height: 40%;
            // background-color: #57ec54;
            .middle_left{
                width: 86%;
                display: flex;
                .left_link{
                    width: 80%;
                    display: flex;
                    .link_item{
                        width: 25%;
                        .title{
                            color: #dadada;
                            margin-bottom: 1.44rem;
                        }
                        .title_child{
                            font-family: AliRegular;
                            color: #969696;
                            margin-bottom: 1.13rem;
                        }
                        span{
                            cursor: pointer;
                        }
                    }
                }
                .right_link{
                    width: 20%;
                    p{
                        color: #dadada;
                        margin-bottom: 1.5rem;
                        font-family: AliMedium;
                        span{
                            cursor: pointer;
                        }
                    }
                }
            }
            .middle_right{
                width: 14%;
                min-width: 132px;
                .right_number{
                    // margin-left: 1%;
                    p{
                        font-family: AliMedium;
                    }
                    // padding-left: 0.7rem;
                    p::before{
                        content: url(../../assets/footer/资源\ 58.png);
                        vertical-align: middle;
                        margin-right: 0.5rem; /* 可选：添加间距 */
                    }
                }
                .right_code{
                    margin-top: 5%;
                    margin-left: 25%;
                }
            }
        }
        .footer_middle_bottom{
            display: flex;
            justify-content: space-between;
            margin-top: 2%;
            .bottom_contact{
                display: flex;
                width: 22%;
                color: #ffffff;
            }
            .contact_border{
                border-right: 1px solid #969696;
            }
            .contact_border_inner{
                // background-color: #54ceec;
                display: flex;
            }
        }
        .footer_bottom{
            width: 80%;
            margin: 5% auto 0 auto;
            // border-top: 1px dotted rgb(203, 203, 203);
            text-align: center;
            .copyright{
                color: #969696;
                font-family: AliRegular;
                a:hover{
                    color: #1366ec;
                }
            }
            
            .copyright::before{
                content: "Copyright";
                color: #54ceec;
                font-family: AliRegular;
            }
        }
    }
    .dialog-container{
        ::v-deep .el-dialog{
            border-radius: 15px;
        }
        .header{
            background-color: aquamarine;
            width: 95%;
            margin: 0 auto 20px;
            .avatar{
                padding: 4px;
                background: linear-gradient(to right, #b2d4f9, #edf5ff);
                img{
                    width: 70px;
                    height: 70px;
                    border-radius: 90%;
                }
                
            }
        }
        .container{
            width: 95%;
            margin: 0 auto;
            // background-color: #54ceec;
        }
        .form-container{
            ::v-deep .el-form-item{
                width: 45%;
                .el-form-item__label{
                    border: 1px #DCDFE6 solid;
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    background-color: #f1f1f2;
                    border-right: none;
                }
                .el-form-item__content{
                    .el-input{
                        // background-color: red;
                        .el-input__inner{
                            // border-left: none;
                            border-top-left-radius: 0;
                            border-bottom-left-radius: 0;
                            border-top-right-radius: 4px;
                            border-top-right-radius: 4px;
                            height: 42px;
                            line-height: 42px;
                        }
                    }
                }
                
            }
            .top{
                display: flex;
                justify-content: space-between;
            }
            .bottom{
                display: flex;
                justify-content: space-between;
            }
            .content{
            //     margin: 0;
            width: 100%;
                ::v-deep .el-form-item__content{
                    margin-left: 0 !important;
                }
            }
            .btn{
                display: flex;
                justify-content: right;
                width: 100%;
                .el-button{
                    background-color: #54ceec;
                    color: #000;
                    padding: 6px 20px;
                    border-radius: 18px;
                }
            }
        }
    }
    @media screen and (min-width: 1500px) {
        .footer_container{
            width: 60%;
        }
    }
    @media screen and (min-width: 1680px) {
        .footer_container{
            width: 72rem;
            min-width: 60rem;
        }
    }
}
@media screen and (max-width: 1800px) {
    .footer {
        height: 33.38rem;
        .left_link{
            .title{
                font-size: 1rem;
            }
            .title_child{
                font-size: 0.85rem;
            }
        }
        .right_link{
            p{
                color: #dadada;
                font-size: 1rem;
            }
        }
    }
    .copyright {
        font-size: 0.9rem;
        // background-color: #54ceec;
    }
}
@media screen and (min-width: 1800px)  and (max-width: 2300px) {
    .footer {
        height: 36.38rem;
        .left_link{
            .title{
                font-size: 1.2rem;
            }
            .title_child{
                font-size: 0.9rem;
            }
        }
        .right_link{
            p{
                color: #dadada;
                font-size: 1.2rem;
            }
        }
    }
    .copyright {
        font-size: 1.08rem;
        // background-color: #54ec93;
    }
}
</style>